<template>
    <layout-with-sidebar>
            <HeaderComponent/>
            <div class="container " >
              <div class="d-flex align-items-center mt-4">
                <h3 class="h5 p-0 mb-0 pr-3">Cambiali</h3>
                  <router-link type="button" to="/amortizations/create" tag="button" class="btn btn-success btn-sm ">Nuovo</router-link>
                  <!-- ml-auto -->
              </div>
              <CambialiTable/>
            </div>
    </layout-with-sidebar>
</template>

<script>
  import LayoutWithSidebar from '../../components/layouts/LayoutWithSidebar.vue'
  import HeaderComponent from '../../components/HeaderComponent.vue'
  // import CambialeAddModal from './CambialeAddModal.vue'
  import CambialiTable from '../../components/CambialiTable.vue'
  import axios from 'axios'

  export default {
    name: 'Amortizations',
    components: {
      LayoutWithSidebar: LayoutWithSidebar,
      HeaderComponent: HeaderComponent,
      CambialiTable,
    },
    data: function () {
      return {
        amortizations: [],
      }
    },
    computed: {},
    methods: {
      getAmortizations: function () {
        var $vm = this
        axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/' + $vm.loggedUser.id + '/amortizations?filter=CONFIRMED')
          .then(function (response) {
            $vm.amortizations = response.data
          })
      },
      deleteAmortization: function (id) {
        var $vm = this
        // Trigger a confirmation dialog
        this.$dialog
          .confirm('Sei sicuro di voler cancellare?',{cancelText: 'Annulla', okText: 'Conferma'})
          .then(function (dialog) {
            axios.delete(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + id)
              .then(function (response) {
                $vm.getAmortizations()
              })
          })
          .catch(function () {
          })

      }
    }
  }

</script>

<style scope>

    .ed-bg{
        background-color: #272F44;
        background-color: #222939;
        color: white;
    }
</style>
